import React, { createContext, useState, useContext, useEffect } from 'react';
import { isAuthenticated, isAdmin } from '../features/auth/services/authService';
import { ColorService } from '../features/colors';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  const [adminStatus, setAdminStatus] = useState(isAdmin());
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const initializeUserData = () => {
      const isAuth = isAuthenticated();
      setAuthenticated(isAuth);
      setAdminStatus(isAdmin());
      
      if (isAuth) {
        const userId = sessionStorage.getItem('user_id');
        const userName = sessionStorage.getItem('user_name');
        const userEmail = sessionStorage.getItem('user_email');
        const userRole = sessionStorage.getItem('user_role');
        
        if (userId) {
          const user = { 
            id: userId, 
            name: userName, 
            email: userEmail,
            role: userRole
          };
          
          setCurrentUser(user);
        }
      } else {
        setCurrentUser(null);
      }
    };

    initializeUserData();

    const handleStorageChange = (event) => {
      if (event.key === 'user_id' || event.key === 'token') {
        initializeUserData();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!authenticated) {
      setCurrentUser(null);
    }
  }, [authenticated]);

  const updateUserData = (userData) => {
    if (userData && userData.id) {
      setCurrentUser(userData);
      setAuthenticated(true);
      setAdminStatus(userData.role === 'admin');
    } else {
      setCurrentUser(null);
      setAuthenticated(false);
      setAdminStatus(false);
    }
  };

  const value = {
    authenticated,
    isAdmin: adminStatus,
    currentUser,
    setAuthenticated,
    setAdminStatus,
    setCurrentUser: updateUserData
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};